/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {LinksData} from '../../core/_models'

type Props = {
  embeddings: LinksData
}

const UserInfoCell: FC<Props> = ({embeddings}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
   
    <div>
    <a target='_blank' href={embeddings.link?? ''} className='d-flex flex-column custom-highlighted-links'>{embeddings.link?? ''}</a>
    {/* <div className='d-flex flex-column'>{embeddings.filePath?? ''}</div> */}

</div>    
  </div>
)

export {UserInfoCell}
